var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDevLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 22,
    viewBox: "0 0 107 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.91507 4H0V6.8H2.91507V4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5753 15.2H11.6603V18H14.5753V15.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5753 9.6C14.5753 8.05356 13.9228 6.65356 12.8677 5.64024C11.8127 4.62678 10.3552 4 8.74521 4H2.91507L4.0811 6.8H8.74521C9.5502 6.8 10.279 7.11332 10.8065 7.62012C11.3341 8.12678 11.6603 8.82678 11.6603 9.6C11.6603 10.9619 10.648 12.0968 9.30665 12.3481C9.12504 12.3822 8.93731 12.4 8.74521 12.4H6.41315L8.74521 18L11.6603 18L10.3991 14.9714C12.8133 14.2866 14.5753 12.141 14.5753 9.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7626 12.4H80.7558V9.6H73.7626V6.8H81.3418L82.5078 4H70.8476L70.8475 18H82.5078V15.2H73.7626V12.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5165 15.2L61.5165 4H58.6014L58.6014 18H70.2617V15.2H61.5165Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107 4H95.3397V6.8H99.7123L99.7123 18H102.627L102.627 6.8H107V4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8496 6.8L58.0156 4H46.3553L46.3553 18H49.2703V12.4H56.2635V9.6H49.2703V6.8H56.8496Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7781 12.4H21.863V18H24.7781V12.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5233 9.6C33.5233 8.05356 32.8708 6.65356 31.8156 5.64024C30.7607 4.62678 29.3031 4 27.6931 4H21.863L23.029 6.8H27.6931C28.4981 6.8 29.2269 7.11332 29.7544 7.62012C30.282 8.12678 30.6082 8.82678 30.6082 9.6C30.6082 10.9619 29.596 12.0968 28.2546 12.3481C28.073 12.3822 27.8853 12.4 27.6931 12.4H25.3611L27.6931 18H30.6082L29.347 14.9714C31.7613 14.2866 33.5233 12.141 33.5233 9.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7539 4H91.1101L86.0087 9.71662V4H83.0936V18H86.0087V13.8L86.6854 13.0416L91.1101 18H94.7539L88.5074 11L94.7539 4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0242 15.2V12.4H44.0174V9.59999H37.0242L37.0242 6.8H44.6034L45.7694 4H34.1091L34.1091 18H45.7694V15.2H37.0242Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevLogo);
export default __webpack_public_path__ + "static/media/dev-logo.18f9a2380d1629bebef0011972e6968e.svg";
export { ForwardRef as ReactComponent };